import { render, staticRenderFns } from "./splitOrderModal.vue?vue&type=template&id=06c4d093&scoped=true"
import script from "./splitOrderModal.vue?vue&type=script&lang=js"
export * from "./splitOrderModal.vue?vue&type=script&lang=js"
import style0 from "./splitOrderModal.vue?vue&type=style&index=0&id=06c4d093&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c4d093",
  null
  
)

export default component.exports